<script setup lang="ts">
</script>

<template>
    <div></div>
    <!-- <AnnouncementsLayout :announcements="announcements" /> -->
</template>

<style scoped lang="scss">
.announcements-layout {
    overflow-x: auto;
    padding-bottom: 0.5em;
}
</style>
